export const TEXT = {
  code: '404',
  title: 'Page Not Found',
  link: 'Back to home',
};
